// 권위: dashboard-api /api/v1/sector-intelligence 계약
// envelope 언랩은 apiClient interceptor 가 처리 (data 만 도달).

export type SectorType = 'PRIMARY' | 'SECONDARY' | 'THEME';

export const ALL_SECTOR_TYPES: SectorType[] = ['PRIMARY', 'SECONDARY', 'THEME'];

export interface SectorIntelItem {
  symbol: string;
  stockName: string | null;
  sectorType: SectorType;
  sectorName: string;
  source: string;
  confidence: number;
  validFrom: string;      // "YYYY-MM-DD"
  validTo: string | null; // "YYYY-MM-DD" | null
  createdAt: string;      // ISO8601
  /** sector_mapping 매핑 결과: 정규(canonical) 섹터 id. 미매핑 시 null. */
  canonicalSectorId: string | null;
  /** sector_taxonomy.display_name. canonicalSectorId 가 null 이면 null. */
  canonicalDisplayName: string | null;
}

export interface SectorIntelListResponse {
  items: SectorIntelItem[];
  total: number;
}

export interface SectorGroupItem {
  sectorType: SectorType;
  sectorName: string;
  source: string;
  stockCount: number;
  validFrom: string;      // "YYYY-MM-DD"
  validTo: string | null; // "YYYY-MM-DD" | null
  /** (source, sectorName) 그룹에 대응하는 canonical 섹터 id. 미매핑 시 null. */
  canonicalSectorId: string | null;
  /** sector_taxonomy.display_name. canonicalSectorId 가 null 이면 null. */
  canonicalDisplayName: string | null;
}

export interface SectorGroupsListResponse {
  items: SectorGroupItem[];
  total: number;
}

export interface SectorIntelFilterOptions {
  sectorTypes: string[];
  sources: string[];
}

export interface SectorIntelFilters {
  sectorTypes: SectorType[];
  sources: string[];
  sectorName: string;
  /** 종목명 검색 (stock_master.name ILIKE). 비어있으면 무시. */
  stockName: string;
  /** canonical(정규) 섹터 id 정확 일치 필터. 빈 문자열이면 무시. */
  canonicalSectorId: string;
  activeOnly: boolean;
  page: number;
  size: number;
}

export const DEFAULT_SECTOR_INTEL_FILTERS: SectorIntelFilters = {
  sectorTypes: [],
  sources: [],
  sectorName: '',
  stockName: '',
  canonicalSectorId: '',
  activeOnly: false,
  page: 0,
  size: 100,
};

const SOURCE_LABEL_KO: Record<string, string> = {
  naver_theme: '네이버 테마',
  naver_upjong: '네이버 업종',
};

export function formatSource(source: string): string {
  return SOURCE_LABEL_KO[source] ?? source;
}
